export function parseDateOrFallback(value: any, fallback: Date = new Date(0)): Date {
  if (value === null || value === undefined || value === '') return fallback;
  if (value instanceof Date) return isNaN(value.getTime()) ? fallback : value;
  let d: Date;
  if (typeof value === 'string') {
    // Detect ISO date-only strings (YYYY-MM-DD) and create a local Date
    const isoDateOnly = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoDateOnly) {
      const y = Number(isoDateOnly[1]);
      const m = Number(isoDateOnly[2]);
      const day = Number(isoDateOnly[3]);
      d = new Date(y, m - 1, day); // local date
    } else {
      d = new Date(value);
    }
  } else {
    d = new Date(value);
  }
  return isNaN(d.getTime()) ? fallback : d;
}

/** Fecha local de hoy como yyyy-MM-dd. */
export function fechaHoyIso(): string {
  const hoy = new Date();
  return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;
}

/** yyyy-MM-dd → dd-MM-yyyy (formato que esperan obtenerCotizacion y los avisos). */
export function isoADisplay(iso: string): string {
  const [year, month, day] = (iso || '').split('-');
  return `${day}-${month}-${year}`;
}

/**
 * fechaOperacion para registraroperacion: el backend la deserializa con @JsonFormat "yyyy-MM-dd HH:mm".
 * Hoy lleva la hora actual; una fecha pasada (Sincro permite elegirla), 00:00.
 */
export function fechaOperacionBackend(iso: string): string {
  if (iso !== fechaHoyIso()) return `${iso} 00:00`;
  const ahora = new Date();
  return `${iso} ${String(ahora.getHours()).padStart(2, '0')}:${String(ahora.getMinutes()).padStart(2, '0')}`;
}

/** Lunes a viernes; un yyyy-MM-dd se interpreta como fecha local (new Date(iso) sería UTC). */
export function esDiaHabil(fecha: string | Date): boolean {
  const dia = parseDateOrFallback(fecha, new Date(NaN)).getDay();
  return dia >= 1 && dia <= 5;
}
